import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 17v2a3 3 0 0 1 -3 3h-4a3 3 0 0 1 -3 -3v-2z","key":"svg-0"}],["path",{"d":"M8 2a2 2 0 0 1 1.732 1h1.15a1.496 1.496 0 0 1 2.236 0h1.882a1 1 0 0 1 0 2l-1.883 .001a2 2 0 0 1 -.115 .116v.983a5 5 0 0 1 3.998 4.9v4h-10v-4a5 5 0 0 1 4 -4.9v-.983a2 2 0 0 1 -.117 -.116h-1.151a2 2 0 1 1 -1.732 -3.001","key":"svg-1"}]]

const IconScubaDivingTankFilled = createReactComponent('filled', 'scuba-diving-tank-filled', 'ScubaDivingTankFilled', __iconNode);

export default IconScubaDivingTankFilled;